// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rectangle
{
    display: flex;
    flex-direction: column;
    align-items: center;
    display: flex;
    width: 335px;
    padding: 16px 12px 12px 12px;
    justify-content: center;
    align-items: center;
    gap: 10px; 
    border-radius: 24px;
    background: 24px;
    background: linear-gradient(99deg, #053D35 0%, #2E6457 48.64%, #053D35 100%); 
}

.text
{
    color: var(--White, #FFF);
text-align: center;
font-family: 'SuisseIntl';
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 23px; /* 143.75% */ 
}

.button
{
    width: 311px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 14px;
    background: var(--White, #FFF); 
    border: 0px solid var(--Coffeemania-Orange, #FFF);
    display: inline-flex;
    gap: 4px; 
    align-items: center;
    align-content: center;
    display: flex;
}

.textButton
{
    color: var(--Text-dark, #373737);
    font-family: 'SuisseIntl';
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    align-items: center;
    display: flex;
}

.pos_text_img
{
    display: inline-flex;
    gap: 4px; 
    align-items: center;
    text-align: center;
    margin: 0 auto;

}

.map_img_style
{
    text-align: center;
    width: 24px;
    height: 24px;
    display: flex;
}

`, "",{"version":3,"sources":["webpack://./src/components/SendRevMap/SendRevMap.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,4EAA4E;AAChF;;AAEA;;IAEI,yBAAyB;AAC7B,kBAAkB;AAClB,yBAAyB;AACzB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,YAAY;AAC/B;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,iDAAiD;IACjD,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;;IAEI,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".rectangle\r\n{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    display: flex;\r\n    width: 335px;\r\n    padding: 16px 12px 12px 12px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px; \r\n    border-radius: 24px;\r\n    background: 24px;\r\n    background: linear-gradient(99deg, #053D35 0%, #2E6457 48.64%, #053D35 100%); \r\n}\r\n\r\n.text\r\n{\r\n    color: var(--White, #FFF);\r\ntext-align: center;\r\nfont-family: 'SuisseIntl';\r\nfont-size: 16px;\r\nfont-style: normal;\r\nfont-weight: 400;\r\nline-height: 23px; /* 143.75% */ \r\n}\r\n\r\n.button\r\n{\r\n    width: 311px;\r\n    height: 50px;\r\n    flex-shrink: 0;\r\n    border-radius: 14px;\r\n    background: var(--White, #FFF); \r\n    border: 0px solid var(--Coffeemania-Orange, #FFF);\r\n    display: inline-flex;\r\n    gap: 4px; \r\n    align-items: center;\r\n    align-content: center;\r\n    display: flex;\r\n}\r\n\r\n.textButton\r\n{\r\n    color: var(--Text-dark, #373737);\r\n    font-family: 'SuisseIntl';\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 15px;\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n\r\n.pos_text_img\r\n{\r\n    display: inline-flex;\r\n    gap: 4px; \r\n    align-items: center;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n\r\n}\r\n\r\n.map_img_style\r\n{\r\n    text-align: center;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
